export const PERMISSIONS = {
  fieldpermission_carrier_notifications:
    "fieldpermission.carrier.notifications.view",
};
